<script setup lang="ts">
import { ref } from 'vue'
import Popover from 'primevue/popover'

interface Props {
  dismissable?: boolean
}

withDefaults(defineProps<Props>(), {
  dismissable: true,
})

const popoverRef = ref<InstanceType<typeof Popover> | null>(null)

const show = (event: Event) => popoverRef.value?.show(event)
const hide = () => popoverRef.value?.hide()
const toggle = (event: Event) => popoverRef.value?.toggle(event)

defineExpose({ show, hide, toggle })
</script>

<template>
  <Popover ref="popoverRef" :dismissable="dismissable" class="app-popover">
    <slot />
  </Popover>
</template>

<style>
/* Unscoped on purpose -- targets PrimeVue inner / teleported DOM that scoped CSS cannot reach. */
/* Not scoped — targets the PrimeVue portal-rendered element */
.app-popover.p-popover {
  border-radius: 14px;
  border: 1px solid var(--p-primary-500);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  padding: 0;
  overflow: hidden;
  min-width: 220px;
}

.app-popover.p-popover .p-popover-content {
  padding: 0;
}

/* Hide default arrow */
.app-popover.p-popover-flipped .p-popover-arrow,
.app-popover.p-popover .p-popover-arrow {
  display: none;
}
</style>
